/******/ (function() { // webpackBootstrap
var __webpack_exports__ = {};
class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.config = {
      autorotate: this.dataset.autorotate === 'true',
      autorotateSpeed: parseInt(this.dataset.autorotateSpeed) * 1000,
      moveTime: parseFloat(this.dataset.speed),
      // 100px going to move for
      space: 100 // 100px
    };
    this.measuredHeight = null;
    this.getMeasuredHeight();
    if (theme.config.mqlSmall) {
      this.initOnMobile();
    } else {
      this.initOnDesktop();
    }
    document.addEventListener('matchSmall', () => {
      this.unload();
      this.initOnMobile();
    });
    document.addEventListener('unmatchSmall', () => {
      this.unload();
      this.initOnDesktop();
    });
  }
  initOnDesktop() {
    switch (this.dataset.layout) {
      case 'carousel':
        this.initCarousel();
        break;
      case 'marquee':
        this.initMarquee();
        break;
      default:
        this.initMarqueeOptimized();
    }
  }
  initOnMobile() {
    switch (this.dataset.mobileLayout) {
      case 'carousel':
        this.initCarousel();
        break;
      case 'marquee':
        this.initMarquee();
        break;
    }
  }
  unload() {
    if (this.flickity && typeof this.flickity.destroy === 'function') {
      this.flickity.destroy();
      this.removeNextPrevListeners();
    }
    if (this.classList.contains('marquee')) {
      this.classList.remove('marquee');
      this.querySelectorAll('.announcement-slider[aria-hidden]').forEach(slider => {
        slider.remove();
      });
    }
    if (this.observer && typeof this.observer.unobserve === 'function') {
      this.observer.unobserve(this);
    }
    this.measuredHeight = null;
    const slider = this.querySelector('.announcement-slider');
    if (slider) {
      slider.style.removeProperty('height');
      slider.style.removeProperty('min-height');
      const slides = slider.querySelectorAll('.announcement-slider__slide');
      for (var i = 0; i < slides.length; i++) {
        slides[i].style.removeProperty('min-height');
      }
    }
  }
  getMeasuredHeight() {
    if (this.measuredHeight !== null) {
      return this.measuredHeight;
    }
    let value = '';
    if (typeof window !== 'undefined' && window.getComputedStyle) {
      value = window.getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-height');
    }
    const parsed = parseFloat(value);
    this.measuredHeight = isNaN(parsed) ? 36 : parsed;
    return this.measuredHeight;
  }
  applyMeasuredHeight(slider, height, options) {
    if (!slider) {
      return;
    }
    const config = options || {};
    const resolved = Math.max(Math.ceil(height || 0), 36);
    slider.style.minHeight = `${resolved}px`;
    if (config.forceHeight) {
      slider.style.height = `${resolved}px`;
    }
    const slides = slider.querySelectorAll('.announcement-slider__slide');
    for (let i = 0; i < slides.length; i++) {
      slides[i].style.minHeight = `${resolved}px`;
    }
  }
  refreshMeasuredHeight(options) {
    const slider = this.querySelector('.announcement-slider');
    if (!slider) {
      return;
    }
    const config = options || {};
    const slides = slider.querySelectorAll('.announcement-slider__slide');
    let maxHeight = 0;
    for (let i = 0; i < slides.length; i++) {
      const slide = slides[i];
      const previousDisplay = slide.style.display;
      const previousHeight = slide.style.height;
      const previousMinHeight = slide.style.minHeight;
      const computedDisplay = typeof window !== 'undefined' && window.getComputedStyle ? window.getComputedStyle(slide).display : '';
      const wasHidden = computedDisplay === 'none';
      if (wasHidden) {
        slide.style.display = 'flex';
      }
      slide.style.height = 'auto';
      slide.style.minHeight = 'auto';
      const height = Math.ceil(slide.getBoundingClientRect().height);
      if (height > maxHeight) {
        maxHeight = height;
      }
      slide.style.height = previousHeight;
      slide.style.minHeight = previousMinHeight;
      if (wasHidden) {
        slide.style.display = previousDisplay || '';
      }
    }
    if (!maxHeight) {
      maxHeight = this.getMeasuredHeight();
    }
    maxHeight = Math.max(Math.ceil(maxHeight), 36);
    this.measuredHeight = maxHeight;
    document.documentElement.style.setProperty('--announcement-bar-height', `${maxHeight}px`);
    this.applyMeasuredHeight(slider, maxHeight, config);
  }
  initCarousel() {
    const slider = this.querySelector('.announcement-slider');
    this.applyMeasuredHeight(slider, this.getMeasuredHeight(), {
      forceHeight: true
    });
    if (!slider) {
      return;
    }
    if (this.dataset.blockCount == 1) {
      this.refreshMeasuredHeight({
        forceHeight: true
      });
      return;
    }
    setTimeout(() => {
      this.flickity = new Flickity(slider, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        setGallerySize: false,
        autoPlay: this.config.autorotate ? this.config.autorotateSpeed : false
      });
      if (this.flickity && typeof this.flickity.on === 'function') {
        this.flickity.on('ready', () => {
          this.refreshMeasuredHeight({
            forceHeight: true
          });
        });
      }
    });
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.onNextPrevClick = this.handleNextPrevClick.bind(this);
    this.prevButton && this.prevButton.addEventListener('click', this.onNextPrevClick);
    this.nextButton && this.nextButton.addEventListener('click', this.onNextPrevClick);
    this.refreshMeasuredHeight({
      forceHeight: true
    });
  }
  removeNextPrevListeners() {
    this.prevButton && this.prevButton.removeEventListener('click', this.onNextPrevClick);
    this.nextButton && this.nextButton.removeEventListener('click', this.onNextPrevClick);
  }
  handleNextPrevClick(event) {
    event.preventDefault();
    const target = event.currentTarget;
    if (target.name === 'next') {
      this.flickity && this.flickity.next();
    } else if (target.name === 'previous') {
      this.flickity && this.flickity.previous();
    }
    if (this.flickity.player) {
      this.flickity.stopPlayer();
    }
  }
  initMarqueeOptimized() {
    const slider = this.querySelector('.announcement-slider');
    this.applyMeasuredHeight(slider, this.getMeasuredHeight());
    setTimeout(() => {
      this.marqueeAnimation();
      this.refreshMeasuredHeight();
    });

    // pause when out of view
    this.observer = new IntersectionObserver((entries, _observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.isAnimated && this.classList.remove('marquee--paused');
        } else {
          this.isAnimated && this.classList.add('marquee--paused');
        }
      });
    }, {
      rootMargin: '0px 0px 50px 0px'
    });
    this.observer.observe(this);
    window.addEventListener('resize', this.marqueeAnimation.bind(this));
    this.refreshMeasuredHeight();
  }
  marqueeAnimation() {
    const slider = this.querySelector('.announcement-slider');
    if (!slider) {
      return;
    }
    if (slider.scrollWidth > this.clientWidth) {
      if (!this.isAnimated) {
        for (let index = 0; index < 2; index++) {
          const clone = slider.cloneNode(true);
          clone.setAttribute('aria-hidden', true);
          this.appendChild(clone);
        }
        this.classList.add('marquee');
        this.style.setProperty('--duration', `${slider.scrollWidth / this.config.space * this.config.moveTime}s`);
        this.isAnimated = true;
      }
    } else if (this.isAnimated) {
      for (let index = 0; index < 2; index++) {
        this.removeChild(this.lastElementChild);
      }
      this.classList.remove('marquee');
      this.isAnimated = false;
    }
    this.refreshMeasuredHeight();
  }
  initMarquee() {
    const slider = this.querySelector('.announcement-slider');
    this.applyMeasuredHeight(slider, this.getMeasuredHeight());
    if (!slider) {
      return;
    }
    setTimeout(() => {
      const baseSlider = slider;
      for (let index = 0; index < 10; index++) {
        const clone = baseSlider.cloneNode(true);
        clone.setAttribute('aria-hidden', true);
        this.appendChild(clone);
      }
      this.classList.add('marquee');
      this.style.setProperty('--duration', `${baseSlider.clientWidth / this.config.space * this.config.moveTime}s`);
      this.refreshMeasuredHeight();
    });

    // pause when out of view
    this.observer = new IntersectionObserver((entries, _observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.classList.remove('marquee--paused');
        } else {
          this.classList.add('marquee--paused');
        }
      });
    }, {
      rootMargin: '0px 0px 50px 0px'
    });
    this.observer.observe(this);
  }
}
customElements.define('announcement-bar', AnnouncementBar);
/******/ })()
;